<template>
  <div id="trainer-teachers">
    <b-container id="trainer-teachers-table" fluid>
      <b-row class="mt-4">
        <b-col cols="5">
          <br />
          <b-col>
            <h4 class="subtitle">
              Trainer's Current Teachers ({{ teachersTable.length }})
            </h4>
            <b-form-group>
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-table
              v-cloak
              responsive
              :fields="trainerTeachersFields"
              :items="teachersTable"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              small
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered"
            >
              <template slot="cell(name)" slot-scope="row" v-if="teachersTable">
                <b-link
                  @click.stop="stopClick"
                  :to="{
                    name: 'EditTeacher',
                    params: { id: row.item.teacher_uuid },
                  }"
                  >{{ row.item.name }}</b-link
                >
                <br />
                <p class="small-date">school: {{ row.item.school_name }}</p>
                <br />
                <p class="small-date">HT?: {{ row.item.head_teacher }}</p>
              </template>
              <!-- <template slot="active" slot-scope="row">
                <b-form-radio-group
                  :id="row.item.id.toString()"
                  :value="row.item.active"
                  v-model="row.item.active"
                  @change="updateTrainerTeacher(row)"
                >
                  <b-form-radio :value="true">True</b-form-radio>
                  <b-form-radio :value="false">False</b-form-radio>
                </b-form-radio-group>
              </template>-->
              <template slot="cell(delete)" slot-scope="row">
                <b-link
                  v-if="isAdmin || isSRC"
                  class="delete"
                  @click.stop="deleteTrainerTeacher(row.item)"
                  >Delete Link</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="my-1">
                <b-pagination
                  :total-rows="teachersTable.length || 0"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TrainerService from "../services/TrainerService";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "TrainerTeachers",
  mixins: [flash, scrollTo],
  data() {
    return {
      trainerId: this.$route.params.id ? this.$route.params.id : null,
      isDisabled: true,
      country: "",
      region: "",
      district: "",
      village: "",
      trainerTeachersFields: [
        { key: "name", label: "Name", sortable: true },
        { key: 'consent_given', label: 'Consent Given', sortable: true },
        { key: "delete", label: "DELETE" },
      ],
      trainerSchoolsTeachersFields: [
        { key: "name", label: "Name", sortable: true },
        { key: "id", label: "ADD" },
      ],
      file: this.$route.path.slice(1),
      currentPage: 1,
      country: "",
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: null,
      filterSearchResults: null,
      totalRows: this.rows,
    };
  },
  methods: {
    ...mapActions({
      GET_TRAINER_TEACHERS: "trainers/GET_TRAINER_TEACHERS",
      RESET_TRAINERS_STATE: "trainers/RESET_TRAINERS_STATE",
      RESET_SEARCH: "searches/RESET_SEARCH_STATE",
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredResults(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async updateTrainerTeacher(params) {
      const payload = await {
        id: params.item.id,
        teacher_id: params.item.teacher_id,
        teacher_uuid: params.item.teacher_uuid,
        trainer_uuid: this.$route.params.id,
        active: !params.item.active,
      };
      await TrainerService.updateTrainerTeacher(payload);
      await this.GET_TRAINER_TEACHERS();
    },
    async addTeacherToTrainer(params) {
      const payload = await {
        teacher_id: params.item.teacher_id,
        teacher_uuid: params.item.teacher_uuid,
        trainer_uuid: this.$route.params.id,
        active: true,
      };
      await TrainerService.addTrainerTeacher(payload);
      await this.scrollTo("trainer-teachers-alert");
      await this.flashSuccess();
      await this.GET_TRAINER_TEACHERS();
    },
    async deleteTrainerTeacher(params) {
      const confirmDelete = confirm(
        "Are you sure you want to remove this teacher from this trainer?"
      );
      if (confirmDelete) {
        await TrainerService.deleteTrainerTeacher(params);
        await this.GET_TRAINER_TEACHERS();
      }
    },
    stopClick(row) {},
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
      isSRC: "auth/isSRC",
    }),
    teachers: {
      get() {
        // add some stuff to clean this up
        return this.$store.state.trainers.trainerTeachers;
      },
    },
    teachersTable() {
      //console.log("teachers: ", this.teachers);
      const teachers = this.teachers.map((k) => ({
        id: k.id,
        teacher_id: k.tid,
        teacher_uuid: k.tuuid,
        //name: `${k.first_name} ${k.middle_name} ${k.last_name}`,
        name: k.teacher_name,
        school_name: k.school_name,
        head_teacher: k.head_teacher === true ? "Y" : "N",
        consent_given: k.consent_given == null ? "N" : "Y",
        active: k.active,
      }));
      return teachers;
    },
    rows() {
      return this.schools.length;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.trainerTeachersFields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.GET_TRAINER_TEACHERS();
  },
};
</script>

<style scoped>
.add {
  color: green;
  font-weight: bold;
}
.small-date {
  font-style: italic;
  font-size: 10px;
  color: #5a6269;
}
table th,
table tr {
  text-align: center;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.delete {
  color: #9f020f;
  font-weight: bold;
}
</style>
